/* Formatação e conversões usadas em toda a interface (pt-BR). */

export const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

export const esc = (s: unknown): string =>
  String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string);

export const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

/** Aceita número ou texto em pt-BR ("1.234,5") e em notação com ponto ("1234.5"). */
export function parseNum(s: unknown): number {
  if (typeof s === 'number') return s;
  let t = String(s ?? '').trim();
  if (!t) return NaN;
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  return Number(t);
}

export const num = (v: unknown): number => {
  const n = parseNum(v);
  return Number.isFinite(n) ? n : 0;
};

export const nf = (n: unknown, d = 1): string =>
  num(n).toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d });

export const pct = (v: unknown, t: unknown): string => (num(t) ? `${nf((num(v) / num(t)) * 100, 1)}%` : '—');

/** Texto sem acento, minúsculo e só com letras/números, para comparar nomes. */
export const norm = (s: unknown): string =>
  String(s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

export const lista = <T>(d: unknown): T[] => (Array.isArray(d) ? (d as T[]) : []);

export const dataBR = (iso: unknown): string => {
  const m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(iso || '—');
};

export const isoDe = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** "15/03/2026" → "2026-03-15"; outros formatos ficam com os 10 primeiros caracteres. */
export const isoDeTexto = (s: unknown): string => {
  const m = String(s || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  return m ? `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}` : String(s || '').slice(0, 10);
};

export function dataHoraBR(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return esc(iso || '');
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export const unidadeTela = (u: string): string => ({ m3: 'm³', m2: 'm²' })[u] || u;
